import VisibleComponent from '../VisibleComponent'
import { fetchDataByAjax } from '../../../../common/util'
import './index.less'
import i18nTools from "../../../../common/locale/format";

const template = `
  <div class="mtg-recommend-box">
    <div class="mtg-recommend-title"></div>
    <div class="mtg-recommend-list-box">
      <ul class="mtg-recommend-list"></ul>
    </div>
  </div>
`

/**
 * MoreOffer类
 * @constructor
 * @extends VisibleComponent
 * @param options 构造参数
 */
class MoreOffer extends VisibleComponent {
  constructor(options = {}) {
    super(options)
    this.template = template
    this.mofRes = {}
    // 定义默认配置
    const defaultOpts = {
      offerData:[], // 猜你喜欢offer数据列表
      url:"", // 猜你喜欢请求url
      minLength:5, // 最少请求猜你喜欢的个数
      maxLength: 20, // 最多请求猜你喜欢个数
      showTitle:true, // 展示左侧猜你喜欢标题
      showOfferTitle :true, // 展示猜你喜欢底部文字
      offerTitleColor: "#999", // 猜你喜欢底部文字颜色
      titleColor: "#333", // 猜你喜欢左侧标题文字颜色
      bgColor :'#fff', // 背景颜色
      title:i18nTools.formatByUA('_just_for_you'), // 猜你喜欢左侧标题
      onOfferClick:"", // offer点击事件
      onLoadSuccess:[], // 加载成功后执行函数列表
      onLoadFailed:[], // 加载失败后执行函数列表
    }
    // 传入的配置覆盖掉默认配置
    this.opts = Object.assign(defaultOpts,options)
    console.log("more offer options",this.opts)
    this.init(this.opts)
  }

  init(opts) {
    super.init()

    Array.isArray(this.opts.onLoadSuccess) && this.opts.onLoadSuccess.forEach(cb => this.onLoadSuccess(cb))

    Array.isArray(this.opts.onLoadFailed) && this.opts.onLoadFailed.forEach(cb => this.onLoadFailed(cb))

    if (opts['url']) {
      const minLength = this.opts.minLength || 5
      fetchDataByAjax('get', opts['url'], '', (response) => {
        let res
        // 将返回值解析为 object
        try {
          res = JSON.parse(response)
        } catch (e) {
          console.error('res parse failed: ', e)
        }
        this.mofRes = res

        // 如果 response 中返回的 campaign 列表大于 0,
        // 就会认为数据返回正常, 开始走后续的渲染流程
        if (res.status === 1
          && res.data
          && res.data.ads
          && res.data.ads.length >= minLength
        ) {
          this.onlyImpression = res.data.only_impression_url
          this.opts.offerData = res.data.ads
          console.log('Ajax-get Mof data success!', this.opts.offerData)

          if(this.opts.offerData.length > 0) {
            this.iconStatus = new Array(this.opts.offerData.length)
            this.iconStatus.fill(null)
            console.log('icon Status init length: ', this.iconStatus && this.iconStatus.length)
          }

          this.eventManager.fireEvent('loadSuccess')
        } else {
          console.error('EC_MOF: fetch Recommend Data failed: ', res)
          this.eventManager.fireEvent('loadFailed')
        }
      }, (err) => {
        console.error('Ajax request failed!', err)
        this.eventManager.fireEvent('loadFailed')
      })
    } else if (opts['offerData']) {
      this.opts.offerData = opts['offerData']
      console.log('Get mof data success!', this.opts.offerData)

      if(this.opts.offerData.length > 0) {
        this.iconStatus = new Array(this.opts.offerData.length)
        this.iconStatus.fill(null)
        console.log('icon Status init length: ', this.iconStatus && this.iconStatus.length)
      }

      this.eventManager.fireEvent('loadSuccess')
    } else {
      console.error('EC_MOF: Do not have enough info for init!')
      this.eventManager.fireEvent('loadFailed')
    }
  }

  bindVisibleComponentEvent() {
    super.bindVisibleComponentEvent()

    this.mtgRecommendTitle = this.element.querySelector('.mtg-recommend-title')
    this.mtgRecommendList = this.element.querySelector('.mtg-recommend-list')
    this.mtgRecommendListBox = this.element.querySelector('.mtg-recommend-list-box')

    // offer列表绑定点击事件
    this.mtgRecommendList.addEventListener('click', (event) => {
      let mofItem = event.target.closest('.mtg-recommend-item')
      let mofItemCid = Number(mofItem.getAttribute('data-cid'))
      let campaign = this.opts.offerData.filter(c=> c.id === mofItemCid)[0]
      console.log('more offer item clicked: ', {mofItem, mofItemCid, campaign, event, target: event.target})
      this.eventManager.fireEvent('offerClick', {event, campaign})
    }, false)

    // offer列表发生了滚动事件
    this.mtgRecommendListBox.addEventListener('scroll', (event) => {
      console.log('页面发生了滚动')
      const last_known_scroll_position = window.pageXOffset
      this.eventManager.fireEvent('scroll', last_known_scroll_position)
    }, false)

    // offer列表资源载入错误
    this.element.addEventListener('error', (event) => {
      console.log('页面资源载入错误', event)
      this.eventManager.fireEvent('error', event)
    }, false)
  }

  render() {
    let recommemdList = this.opts.offerData.slice(0, this.opts.maxLength)
    let recommendItemHtml = ""
    recommemdList.forEach((item, index) => {
        recommendItemHtml += `
          <li class="mtg-recommend-item" data-cid="${item.id}">
            <img class="js-mtg-recommend-item-img" src="${item.icon_url}" alt="">
            <span class="mtg-recommend-item-title${this.opts.showOfferTitle ? '' : ' hide'}">${item.title}</span>
          </li>
        `
    })
    this.mtgRecommendList.innerHTML = recommendItemHtml
    if (!this.opts.title) {
      this.mtgRecommendTitle.classList.add("hide")
    } else {
      this.mtgRecommendTitle.innerHTML = this.opts.title
    }
    this.mtgRecommendItemTitle = this.element.querySelectorAll('.mtg-recommend-item-title')
    if (this.opts.offerTitleColor !== "#999") {
      Array.from(this.mtgRecommendItemTitle).forEach((item) => item.style.color = this.opts.offerTitleColor)
    }
    if (this.opts.titleColor !== "#333") {
      this.mtgRecommendTitle.style.color = this.opts.titleColor
    }

    // 为前n个img元素绑定 onload oncomplete onerror 事件
    const imgElements = this.mtgRecommendList.querySelectorAll('img')
    Array.from(imgElements).forEach((item, index) => {
      item.addEventListener('load', () => {
        this.iconStatus[index] = true
      })
      item.addEventListener('complete', () => {
        this.iconStatus[index] = true
      })
      item.addEventListener('error', () => {
        this.iconStatus[index] = false
      })
    })
    if(this.opts.bgColor!=="#fff"){
      // 设置背景色
      this.setBG(this.opts.bgColor)
    }
  }

  /**
   * 将当前组件添加到指定组件上
   * @param params
   * @returns {*|Promise<any>}
   */
  appendTo(target) {
    super.appendTo(target)

    // 猜你喜欢插入到页面中的时候，给 target 容器增加 more offer 已打开的标记，以适配猜你喜欢展示后的样式
    if (target) {
      target.classList.add('open-more-offer')
    } else {
      console.error('can not find more offer target', target)
    }
  }

  getMofRes () {
    return this.mofRes
  }

  showOfferTitle() {
    Array.from(document.querySelectorAll('.mtg-recommend-item-title')).forEach((el) => {
      el.classList.remove('hide')
    })
  }

  hideOfferTitle() {
    Array.from(document.querySelectorAll('.mtg-recommend-item-title')).forEach((el) => {
      el.classList.add('hide')
    })
  }

  checkIconStatus(start, end) {
    for (let i = start; i < end; ++i) {
      console.log(Date.now(), 'check Icon Item Status: ', this.iconStatus[i])
      if (this.iconStatus && this.iconStatus[i] === true) {
        // 如果当前 icon 加载成功则暂时不做任何处理
      } else {
        // 如果 "more offer 还未初始化" OR "当前 icon 还没有加载成功" OR "当前icon 加载失败"，则直接返回 false
        return false
      }
    }
    // 如果所有 icon 通过检查，则返回 true
    return true
  }

  onError(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('error', cb)
  }

  onScroll(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('scroll', cb)
  }

  onLoadFailed(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('loadFailed', cb)
  }

  onLoadSuccess(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('loadSuccess', cb)
  }

  onOfferClick(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('offerClick', cb)
  }
}

export default MoreOffer
